<label *ngIf="label" class="col-form-label">
  {{ label }}
  <span *ngIf="isRequired" class="text-danger"> *</span>
  <ng-content></ng-content>
</label>
